// extracted by mini-css-extract-plugin
export default {"imageHoverOverlay":"AbTtJAjeSsxmAiUUYVqM","reattachButtonWrapper":"ofWk9GSHRrj2OceV4DGM","attachmentContainer":"ogTRuV7sSlKz7YFAQwbe"};